<div class='carousel-container'>
    <owl-carousel-o [options]="customOptions">
        <ng-template carouselSlide>
            <div class="first-slide"></div>
        </ng-template>
        <ng-template carouselSlide>
            <div class="second-slide"></div>
        </ng-template>
        <ng-template carouselSlide>
            <div class="third-slide"></div>
        </ng-template>
    </owl-carousel-o>
</div>